export default __webpack_public_path__ + "static/media/cross.32161ef7.svg";